import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Cookies from 'js-cookie';
import logoutApi from '~/core/components/AppMenu/api';
import { CookieKey } from '~/core/enums';
import useProfileStore from '~/stores/useProfileStore';
import useQuestionnaireStore from '~/stores/useQuestionnaireStore';
import useMainStore from '~/stores/useMainStore';
import { PREPARE_MEDCARD_STORAGE_KEY, UNSENT_DOCTOR_QUESTIONS_KEY } from '~/features/Appointments/constants/localStorage';
export var useLogout = function useLogout() {
  var mainStore = useMainStore();
  var profileStore = useProfileStore();
  var questionnaireStore = useQuestionnaireStore();
  var router = useRouter();
  function logout() {
    return _logout.apply(this, arguments);
  }
  function _logout() {
    _logout = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return logoutApi.post();
          case 2:
            Cookies.remove(CookieKey.MedcardToken);
            Cookies.remove(CookieKey.AnonymousQuestionnaireUid);
            localStorage.removeItem(PREPARE_MEDCARD_STORAGE_KEY);
            localStorage.removeItem(UNSENT_DOCTOR_QUESTIONS_KEY);
            mainStore.clear();
            questionnaireStore.clearQuestionnaire();
            profileStore.phone = '';
            router.push({
              name: 'authorization'
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _logout.apply(this, arguments);
  }
  return {
    logout: logout
  };
};